/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseJobsApi } from '../../base-api';
export type GlobalBackupLifecycleSettingsFragment = { __typename: 'GlobalBackupLifecycleSettingsResponseType', tenantId: string, globalRetentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type DeviceBackupLifecycleSettingsFragment = { __typename: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type CreateGlobalBackupLifecycleSettingsMutationVariables = Types.Exact<{
  globalRetentionLimit: Types.Scalars['Int']['input'];
}>;


export type CreateGlobalBackupLifecycleSettingsMutation = { __typename: 'Mutation', createGlobalBackupLifecycleSettings: { __typename: 'GlobalBackupLifecycleSettingsResponseType', tenantId: string, globalRetentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type UpdateGlobalBackupLifecycleSettingsMutationVariables = Types.Exact<{
  globalRetentionLimit: Types.Scalars['Int']['input'];
  objectVersion?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateGlobalBackupLifecycleSettingsMutation = { __typename: 'Mutation', updateGlobalBackupLifecycleSettings: { __typename: 'GlobalBackupLifecycleSettingsResponseType', tenantId: string, globalRetentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type DeleteGlobalBackupLifecycleSettingsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteGlobalBackupLifecycleSettingsMutation = { __typename: 'Mutation', deleteGlobalBackupLifecycleSettings: { __typename: 'GlobalBackupLifecycleSettingsResponseType', tenantId: string, globalRetentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type CreateDeviceBackupLifecycleSettingsMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
  retentionLimit: Types.Scalars['Int']['input'];
}>;


export type CreateDeviceBackupLifecycleSettingsMutation = { __typename: 'Mutation', createDeviceBackupLifecycleSettings: { __typename: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type UpdateDeviceBackupLifecycleSettingsMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
  retentionLimit: Types.Scalars['Int']['input'];
  objectVersion?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateDeviceBackupLifecycleSettingsMutation = { __typename: 'Mutation', updateDeviceBackupLifecycleSettings: { __typename: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type DeleteDeviceBackupLifecycleSettingsMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
}>;


export type DeleteDeviceBackupLifecycleSettingsMutation = { __typename: 'Mutation', deleteDeviceBackupLifecycleSettings: { __typename: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type BulkCreateDeviceBackupLifecycleSettingsMutationVariables = Types.Exact<{
  input: Types.BulkCreateDeviceBackupLifecycleSettingsInput;
}>;


export type BulkCreateDeviceBackupLifecycleSettingsMutation = { __typename: 'Mutation', bulkCreateDeviceBackupLifecycleSettings: { __typename: 'BulkDeviceBackupLifecycleSettingsResponseType', failedDeviceIds: Array<string>, succeeded: Array<{ __typename: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type BulkDeleteDeviceBackupLifecycleSettingsMutationVariables = Types.Exact<{
  input: Types.BulkDeleteDeviceBackupLifecycleSettingsInput;
}>;


export type BulkDeleteDeviceBackupLifecycleSettingsMutation = { __typename: 'Mutation', bulkDeleteDeviceBackupLifecycleSettings: Array<string> };

export type ReadGlobalBackupLifecycleSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadGlobalBackupLifecycleSettingsQuery = { __typename: 'Query', readGlobalBackupLifecycleSettings?: { __typename: 'GlobalBackupLifecycleSettingsResponseType', tenantId: string, globalRetentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type ReadDeviceBackupLifecycleSettingsQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
}>;


export type ReadDeviceBackupLifecycleSettingsQuery = { __typename: 'Query', readDeviceBackupLifecycleSettings?: { __typename: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type ListDeviceBackupLifecycleSettingsQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ListDeviceBackupLifecycleSettingsQuery = { __typename: 'Query', listDeviceBackupLifecycleSettings: { __typename: 'PaginatedDeviceBackupLifecycleSettingsResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type DeploymentRequestActivityFragment = { __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type DeploymentRequestFragment = { __typename: 'DeploymentRequestResponseType', deploymentRequestId: string, title: string, description?: string, deviceId: string, projectId: string, projectVersionId: string, featureOptions?: any, status: Types.DeploymentRequestStatusEnum, approvalExpiresAt?: any, approvedByUserId?: string, approverUserIds: Array<string>, executedByUserId?: string, jobId?: string, isExpired: boolean, objectVersion?: number, creationUserId?: string, creationTimestamp?: any, updateTimestamp?: any, activities: Array<{ __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }>, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, approvers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> };

export type CreateDeploymentRequestMutationVariables = Types.Exact<{
  input: Types.CreateDeploymentRequestInput;
}>;


export type CreateDeploymentRequestMutation = { __typename: 'Mutation', createDeploymentRequest: { __typename: 'DeploymentRequestResponseType', deploymentRequestId: string, title: string, description?: string, deviceId: string, projectId: string, projectVersionId: string, featureOptions?: any, status: Types.DeploymentRequestStatusEnum, approvalExpiresAt?: any, approvedByUserId?: string, approverUserIds: Array<string>, executedByUserId?: string, jobId?: string, isExpired: boolean, objectVersion?: number, creationUserId?: string, creationTimestamp?: any, updateTimestamp?: any, activities: Array<{ __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }>, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, approvers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> } };

export type ApproveDeploymentRequestMutationVariables = Types.Exact<{
  deploymentRequestId: Types.Scalars['String']['input'];
  input?: Types.InputMaybe<Types.ApproveDeploymentRequestInput>;
}>;


export type ApproveDeploymentRequestMutation = { __typename: 'Mutation', approveDeploymentRequest: { __typename: 'DeploymentRequestResponseType', deploymentRequestId: string, title: string, description?: string, deviceId: string, projectId: string, projectVersionId: string, featureOptions?: any, status: Types.DeploymentRequestStatusEnum, approvalExpiresAt?: any, approvedByUserId?: string, approverUserIds: Array<string>, executedByUserId?: string, jobId?: string, isExpired: boolean, objectVersion?: number, creationUserId?: string, creationTimestamp?: any, updateTimestamp?: any, activities: Array<{ __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }>, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, approvers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> } };

export type DenyDeploymentRequestMutationVariables = Types.Exact<{
  deploymentRequestId: Types.Scalars['String']['input'];
  comment?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type DenyDeploymentRequestMutation = { __typename: 'Mutation', denyDeploymentRequest: { __typename: 'DeploymentRequestResponseType', deploymentRequestId: string, title: string, description?: string, deviceId: string, projectId: string, projectVersionId: string, featureOptions?: any, status: Types.DeploymentRequestStatusEnum, approvalExpiresAt?: any, approvedByUserId?: string, approverUserIds: Array<string>, executedByUserId?: string, jobId?: string, isExpired: boolean, objectVersion?: number, creationUserId?: string, creationTimestamp?: any, updateTimestamp?: any, activities: Array<{ __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }>, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, approvers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> } };

export type CancelDeploymentRequestMutationVariables = Types.Exact<{
  deploymentRequestId: Types.Scalars['String']['input'];
  comment?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CancelDeploymentRequestMutation = { __typename: 'Mutation', cancelDeploymentRequest: { __typename: 'DeploymentRequestResponseType', deploymentRequestId: string, title: string, description?: string, deviceId: string, projectId: string, projectVersionId: string, featureOptions?: any, status: Types.DeploymentRequestStatusEnum, approvalExpiresAt?: any, approvedByUserId?: string, approverUserIds: Array<string>, executedByUserId?: string, jobId?: string, isExpired: boolean, objectVersion?: number, creationUserId?: string, creationTimestamp?: any, updateTimestamp?: any, activities: Array<{ __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }>, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, approvers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> } };

export type ExecuteDeploymentRequestMutationVariables = Types.Exact<{
  deploymentRequestId: Types.Scalars['String']['input'];
}>;


export type ExecuteDeploymentRequestMutation = { __typename: 'Mutation', executeDeploymentRequest: { __typename: 'DeploymentRequestResponseType', deploymentRequestId: string, title: string, description?: string, deviceId: string, projectId: string, projectVersionId: string, featureOptions?: any, status: Types.DeploymentRequestStatusEnum, approvalExpiresAt?: any, approvedByUserId?: string, approverUserIds: Array<string>, executedByUserId?: string, jobId?: string, isExpired: boolean, objectVersion?: number, creationUserId?: string, creationTimestamp?: any, updateTimestamp?: any, activities: Array<{ __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }>, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, approvers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> } };

export type DeleteDeploymentRequestMutationVariables = Types.Exact<{
  deploymentRequestId: Types.Scalars['String']['input'];
}>;


export type DeleteDeploymentRequestMutation = { __typename: 'Mutation', deleteDeploymentRequest: { __typename: 'DeploymentRequestResponseType', deploymentRequestId: string, title: string, description?: string, deviceId: string, projectId: string, projectVersionId: string, featureOptions?: any, status: Types.DeploymentRequestStatusEnum, approvalExpiresAt?: any, approvedByUserId?: string, approverUserIds: Array<string>, executedByUserId?: string, jobId?: string, isExpired: boolean, objectVersion?: number, creationUserId?: string, creationTimestamp?: any, updateTimestamp?: any, activities: Array<{ __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }>, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, approvers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> } };

export type UpdateDeploymentRequestApproversMutationVariables = Types.Exact<{
  deploymentRequestId: Types.Scalars['String']['input'];
  input: Types.UpdateDeploymentRequestApproversInput;
}>;


export type UpdateDeploymentRequestApproversMutation = { __typename: 'Mutation', updateDeploymentRequestApprovers: { __typename: 'DeploymentRequestResponseType', deploymentRequestId: string, title: string, description?: string, deviceId: string, projectId: string, projectVersionId: string, featureOptions?: any, status: Types.DeploymentRequestStatusEnum, approvalExpiresAt?: any, approvedByUserId?: string, approverUserIds: Array<string>, executedByUserId?: string, jobId?: string, isExpired: boolean, objectVersion?: number, creationUserId?: string, creationTimestamp?: any, updateTimestamp?: any, activities: Array<{ __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }>, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, approvers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> } };

export type ReadDeploymentRequestQueryVariables = Types.Exact<{
  deploymentRequestId: Types.Scalars['String']['input'];
}>;


export type ReadDeploymentRequestQuery = { __typename: 'Query', readDeploymentRequest: { __typename: 'DeploymentRequestResponseType', deploymentRequestId: string, title: string, description?: string, deviceId: string, projectId: string, projectVersionId: string, featureOptions?: any, status: Types.DeploymentRequestStatusEnum, approvalExpiresAt?: any, approvedByUserId?: string, approverUserIds: Array<string>, executedByUserId?: string, jobId?: string, isExpired: boolean, objectVersion?: number, creationUserId?: string, creationTimestamp?: any, updateTimestamp?: any, activities: Array<{ __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }>, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, approvers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> } };

export type ReadDeploymentRequestsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.DeploymentRequestFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadDeploymentRequestsQuery = { __typename: 'Query', readDeploymentRequests: { __typename: 'PaginatedDeploymentRequestResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'DeploymentRequestResponseType', deploymentRequestId: string, title: string, description?: string, deviceId: string, projectId: string, projectVersionId: string, featureOptions?: any, status: Types.DeploymentRequestStatusEnum, approvalExpiresAt?: any, approvedByUserId?: string, approverUserIds: Array<string>, executedByUserId?: string, jobId?: string, isExpired: boolean, objectVersion?: number, creationUserId?: string, creationTimestamp?: any, updateTimestamp?: any, activities: Array<{ __typename: 'DeploymentRequestActivityType', action: Types.DeploymentRequestActionEnum, userId: string, timestamp: any, comment?: string, subjectUserId?: string, user?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subjectUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }>, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, approvers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> }> } };

export type ReadEligibleDeploymentApproversQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
}>;


export type ReadEligibleDeploymentApproversQuery = { __typename: 'Query', readEligibleDeploymentApprovers: Array<{ __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }> };

export type JobUserInfoFragment = { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean };

export type TargetConfigurationFragment = { __typename: 'TargetConfigurationType', deviceIds?: Array<string>, licenseIds?: Array<string>, projectIds?: Array<string>, projectVersionIds?: Array<string>, targetMetadata?: any };

export type PipelineStepFragment = { __typename: 'PipelineStepConfigurationType', name?: string, description?: string, allowFailure: boolean, type: Types.FeatureEnum, targetConfiguration: Array<{ __typename: 'TargetConfigurationType', deviceIds?: Array<string>, licenseIds?: Array<string>, projectIds?: Array<string>, projectVersionIds?: Array<string>, targetMetadata?: any }> };

export type PipelineConfigurationForSelectFragment = { __typename: 'PipelineConfigurationResponseType', pipelineConfigurationId: string, name: string, groupId?: string, objectVersion?: number, trigger:
    | { __typename: 'PipelineManualTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum }
    | { __typename: 'PipelineScheduledTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum, scheduleType?: Types.PipelineScheduleTypesEnum, expression: string, expressionTimezone?: string }
   };

export type PipelineConfigurationFragment = { __typename: 'PipelineConfigurationResponseType', description?: string, objectVersion?: number, name: string, enabled: boolean, pipelineConfigurationId: string, creationTimestamp?: any, updateTimestamp?: any, groupId?: string, steps: Array<{ __typename: 'PipelineStepConfigurationType', name?: string, description?: string, allowFailure: boolean, type: Types.FeatureEnum, targetConfiguration: Array<{ __typename: 'TargetConfigurationType', deviceIds?: Array<string>, licenseIds?: Array<string>, projectIds?: Array<string>, projectVersionIds?: Array<string>, targetMetadata?: any }> }>, trigger:
    | { __typename: 'PipelineManualTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum }
    | { __typename: 'PipelineScheduledTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum, scheduleType?: Types.PipelineScheduleTypesEnum, expression: string, expressionTimezone?: string }
  , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type TargetExecutionStatusFragment = { __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: Types.PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> };

export type PipelineExecutionStepFragment = { __typename: 'PipelineExecutionStepResponseType', type: Types.FeatureEnum, name?: string, status: Types.PipelineExecutionStatusEnum, allowFailure: boolean, targets: Array<{ __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: Types.PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> }> };

export type PipelineExecutionFragment = { __typename: 'PipelineExecutionResponseType', pipelineConfigurationId: string, pipelineExecutionId: string, name?: string, duration: number, status: Types.PipelineExecutionStatusEnum, errorMessage?: string, creationTimestamp?: any, updateTimestamp?: any, triggerSource:
    | { __typename: 'PipelineManualTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum }
    | { __typename: 'PipelineScheduledTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum, expression: string, expressionTimezone?: string, scheduleType?: Types.PipelineScheduleTypesEnum }
  , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, steps: Array<{ __typename: 'PipelineExecutionStepResponseType', type: Types.FeatureEnum, name?: string, status: Types.PipelineExecutionStatusEnum, allowFailure: boolean, targets: Array<{ __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: Types.PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> }> }> };

export type JobFragment = { __typename: 'JobResponseType', jobId: string, jobType: Types.FeatureEnum, status: Types.JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: Types.JobSourceEnum, featureOptions?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type JobLogFragment = { __typename: 'JobLogType', message: string, timestamp: string };

export type CreatePipelineConfigurationMutationVariables = Types.Exact<{
  pipelineConfiguration: Types.CreatePipelineConfigurationInput;
}>;


export type CreatePipelineConfigurationMutation = { __typename: 'Mutation', createPipelineConfiguration: { __typename: 'PipelineConfigurationResponseType', pipelineConfigurationId: string } };

export type UpdatePipelineConfigurationMutationVariables = Types.Exact<{
  pipelineConfigurationId: Types.Scalars['String']['input'];
  input: Types.UpdatePipelineConfigurationInput;
}>;


export type UpdatePipelineConfigurationMutation = { __typename: 'Mutation', updatePipelineConfiguration: { __typename: 'PipelineConfigurationResponseType', pipelineConfigurationId: string } };

export type DeletePipelineConfigurationMutationVariables = Types.Exact<{
  pipelineConfigurationId: Types.Scalars['String']['input'];
}>;


export type DeletePipelineConfigurationMutation = { __typename: 'Mutation', deletePipelineConfiguration: { __typename: 'PipelineConfigurationResponseType', pipelineConfigurationId: string } };

export type TriggerPipelineExecutionMutationVariables = Types.Exact<{
  pipelineConfigurationId: Types.Scalars['String']['input'];
}>;


export type TriggerPipelineExecutionMutation = { __typename: 'Mutation', triggerPipelineExecution: { __typename: 'PipelineExecutionResponseType', pipelineExecutionId: string } };

export type CreateConversionMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  versionId: Types.Scalars['String']['input'];
}>;


export type CreateConversionMutation = { __typename: 'Mutation', createJob: { __typename: 'JobResponseType', jobId: string } };

export type DeleteJobMutationVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
}>;


export type DeleteJobMutation = { __typename: 'Mutation', deleteJob: { __typename: 'JobResponseType', jobId: string, deviceIds?: Array<string> } };

export type DeletePipelineExecutionMutationVariables = Types.Exact<{
  pipelineExecutionId: Types.Scalars['String']['input'];
}>;


export type DeletePipelineExecutionMutation = { __typename: 'Mutation', deletePipelineExecution: { __typename: 'PipelineExecutionResponseType', pipelineConfigurationId: string, pipelineExecutionId: string } };

export type DownloadArtifactsForJobMutationVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
}>;


export type DownloadArtifactsForJobMutation = { __typename: 'Mutation', downloadArtifactsForJob: { __typename: 'JobArtifactsResponseType', channel?: string, message?: string } };

export type CreateDeviceJobMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
  jobType: Types.FeatureEnum;
  projectIds?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  projectVersionIds?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  featureOptions?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  metaData?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
}>;


export type CreateDeviceJobMutation = { __typename: 'Mutation', createJob: { __typename: 'JobResponseType', jobId: string, jobType: Types.FeatureEnum, status: Types.JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: Types.JobSourceEnum, featureOptions?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type CreateJobMutationVariables = Types.Exact<{
  jobType: Types.FeatureEnum;
  deviceIds?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  projectIds?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  projectVersionIds?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  featureOptions?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  metaData?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
}>;


export type CreateJobMutation = { __typename: 'Mutation', createJob: { __typename: 'JobResponseType', jobId: string, jobType: Types.FeatureEnum, status: Types.JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: Types.JobSourceEnum, featureOptions?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type ReadAllPipelinesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.PipelineConfigurationFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllPipelinesQuery = { __typename: 'Query', readAllPipelineConfigurations: { __typename: 'PaginatedPipelineConfigurationResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'PipelineConfigurationResponseType', description?: string, objectVersion?: number, name: string, enabled: boolean, pipelineConfigurationId: string, creationTimestamp?: any, updateTimestamp?: any, groupId?: string, steps: Array<{ __typename: 'PipelineStepConfigurationType', name?: string, description?: string, allowFailure: boolean, type: Types.FeatureEnum, targetConfiguration: Array<{ __typename: 'TargetConfigurationType', deviceIds?: Array<string>, licenseIds?: Array<string>, projectIds?: Array<string>, projectVersionIds?: Array<string>, targetMetadata?: any }> }>, trigger:
        | { __typename: 'PipelineManualTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum }
        | { __typename: 'PipelineScheduledTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum, scheduleType?: Types.PipelineScheduleTypesEnum, expression: string, expressionTimezone?: string }
      , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadPipelinesForSelectQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.PipelineConfigurationFilterInput>;
}>;


export type ReadPipelinesForSelectQuery = { __typename: 'Query', readAllPipelineConfigurations: { __typename: 'PaginatedPipelineConfigurationResponseType', items: Array<{ __typename: 'PipelineConfigurationResponseType', pipelineConfigurationId: string, name: string, groupId?: string, objectVersion?: number, trigger:
        | { __typename: 'PipelineManualTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum }
        | { __typename: 'PipelineScheduledTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum, scheduleType?: Types.PipelineScheduleTypesEnum, expression: string, expressionTimezone?: string }
       }> } };

export type ReadPipelineExecutionsForPipelineQueryVariables = Types.Exact<{
  pipelineConfigurationId: Types.Scalars['String']['input'];
  filter?: Types.InputMaybe<Types.PipelineExecutionFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadPipelineExecutionsForPipelineQuery = { __typename: 'Query', readAllPipelineExecutionsForConfiguration: { __typename: 'PaginatedPipelineExecutionResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'PipelineExecutionResponseType', pipelineConfigurationId: string, pipelineExecutionId: string, name?: string, duration: number, status: Types.PipelineExecutionStatusEnum, errorMessage?: string, creationTimestamp?: any, updateTimestamp?: any, triggerSource:
        | { __typename: 'PipelineManualTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum }
        | { __typename: 'PipelineScheduledTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum, expression: string, expressionTimezone?: string, scheduleType?: Types.PipelineScheduleTypesEnum }
      , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, steps: Array<{ __typename: 'PipelineExecutionStepResponseType', type: Types.FeatureEnum, name?: string, status: Types.PipelineExecutionStatusEnum, allowFailure: boolean, targets: Array<{ __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: Types.PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> }> }> }> } };

export type ReadPipelineQueryVariables = Types.Exact<{
  pipelineConfigurationId: Types.Scalars['String']['input'];
}>;


export type ReadPipelineQuery = { __typename: 'Query', readPipelineConfiguration: { __typename: 'PipelineConfigurationResponseType', description?: string, objectVersion?: number, name: string, enabled: boolean, pipelineConfigurationId: string, creationTimestamp?: any, updateTimestamp?: any, groupId?: string, steps: Array<{ __typename: 'PipelineStepConfigurationType', name?: string, description?: string, allowFailure: boolean, type: Types.FeatureEnum, targetConfiguration: Array<{ __typename: 'TargetConfigurationType', deviceIds?: Array<string>, licenseIds?: Array<string>, projectIds?: Array<string>, projectVersionIds?: Array<string>, targetMetadata?: any }> }>, trigger:
      | { __typename: 'PipelineManualTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum }
      | { __typename: 'PipelineScheduledTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum, scheduleType?: Types.PipelineScheduleTypesEnum, expression: string, expressionTimezone?: string }
    , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type ReadVersionOriginJobsQueryVariables = Types.Exact<{
  projectIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  jobTypes: Array<Types.FeatureEnum> | Types.FeatureEnum;
  filter?: Types.InputMaybe<Types.JobFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadVersionOriginJobsQuery = { __typename: 'Query', readJobsByProjectIds: { __typename: 'PaginatedJobResponseType', items: Array<{ __typename: 'JobResponseType', jobId: string, jobType: Types.FeatureEnum, metaData?: any, createdProjectVersionId?: string, pipelineExecutionId?: string, pipelineConfigurationId?: string }> } };

export type ReadAllJobsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.JobFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllJobsQuery = { __typename: 'Query', readAllJobs: { __typename: 'PaginatedJobResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'JobResponseType', jobId: string, jobType: Types.FeatureEnum, status: Types.JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: Types.JobSourceEnum, featureOptions?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadJobsByDeviceIdsQueryVariables = Types.Exact<{
  deviceIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  jobTypes: Array<Types.FeatureEnum> | Types.FeatureEnum;
  filter?: Types.InputMaybe<Types.JobFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadJobsByDeviceIdsQuery = { __typename: 'Query', readJobsByDeviceIds: { __typename: 'PaginatedJobResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'JobResponseType', jobId: string, jobType: Types.FeatureEnum, status: Types.JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: Types.JobSourceEnum, featureOptions?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadJobsByProjectIdQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  jobTypes: Array<Types.FeatureEnum> | Types.FeatureEnum;
  filter?: Types.InputMaybe<Types.JobFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadJobsByProjectIdQuery = { __typename: 'Query', readJobsByProjectId: { __typename: 'PaginatedJobResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'JobResponseType', jobId: string, jobType: Types.FeatureEnum, status: Types.JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: Types.JobSourceEnum, featureOptions?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadJobsByProjectIdsQueryVariables = Types.Exact<{
  projectIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  jobTypes: Array<Types.FeatureEnum> | Types.FeatureEnum;
  filter?: Types.InputMaybe<Types.JobFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadJobsByProjectIdsQuery = { __typename: 'Query', readJobsByProjectIds: { __typename: 'PaginatedJobResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'JobResponseType', jobId: string, jobType: Types.FeatureEnum, status: Types.JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: Types.JobSourceEnum, featureOptions?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadLatestJobsByProjectIdsQueryVariables = Types.Exact<{
  projectIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  jobTypes: Array<Types.FeatureEnum> | Types.FeatureEnum;
  filter?: Types.InputMaybe<Types.JobFilterInput>;
  limitPerProject: Types.Scalars['Int']['input'];
}>;


export type ReadLatestJobsByProjectIdsQuery = { __typename: 'Query', readLatestJobsByProjectIds: Array<{ __typename: 'JobResponseType', jobId: string, jobType: Types.FeatureEnum, status: Types.JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: Types.JobSourceEnum, featureOptions?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> };

export type ReadPipelineExecutionQueryVariables = Types.Exact<{
  pipelineExecutionId: Types.Scalars['String']['input'];
}>;


export type ReadPipelineExecutionQuery = { __typename: 'Query', readPipelineExecution: { __typename: 'PipelineExecutionResponseType', pipelineConfigurationId: string, pipelineExecutionId: string, name?: string, duration: number, status: Types.PipelineExecutionStatusEnum, errorMessage?: string, creationTimestamp?: any, updateTimestamp?: any, triggerSource:
      | { __typename: 'PipelineManualTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum }
      | { __typename: 'PipelineScheduledTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum, expression: string, expressionTimezone?: string, scheduleType?: Types.PipelineScheduleTypesEnum }
    , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, steps: Array<{ __typename: 'PipelineExecutionStepResponseType', type: Types.FeatureEnum, name?: string, status: Types.PipelineExecutionStatusEnum, allowFailure: boolean, targets: Array<{ __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: Types.PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> }> }> } };

export type ReadJobQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
}>;


export type ReadJobQuery = { __typename: 'Query', readJob: { __typename: 'JobResponseType', jobId: string, jobType: Types.FeatureEnum, status: Types.JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: Types.JobSourceEnum, featureOptions?: any, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type ReadJobLogsQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
  filter?: Types.InputMaybe<Types.JobLogsFilterInput>;
}>;


export type ReadJobLogsQuery = { __typename: 'Query', readJobLogs: { __typename: 'JobLogsResponseType', nextToken?: string, logs: Array<{ __typename: 'JobLogType', message: string, timestamp: string }> } };

export type ReadPipelineNamesForPolicyRowQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.PipelineConfigurationFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadPipelineNamesForPolicyRowQuery = { __typename: 'Query', readAllPipelineConfigurations: { __typename: 'PaginatedPipelineConfigurationResponseType', items: Array<{ __typename: 'PipelineConfigurationResponseType', name: string, pipelineConfigurationId: string }> } };

export type ReadGroupedPipelinesCountQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type ReadGroupedPipelinesCountQuery = { __typename: 'Query', readAllPipelineConfigurations: { __typename: 'PaginatedPipelineConfigurationResponseType', itemCount: number } };

export type ReadUngroupedPipelinesCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadUngroupedPipelinesCountQuery = { __typename: 'Query', readAllPipelineConfigurations: { __typename: 'PaginatedPipelineConfigurationResponseType', itemCount: number } };

export type ReadGroupedPipelineCountsQueryVariables = Types.Exact<{
  groupIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadGroupedPipelineCountsQuery = { __typename: 'Query', readGroupedPipelineCounts: Array<{ __typename: 'GroupedPipelineCountResponseType', groupId: string, count: number }> };

export type ReadLatestExecutionsForPipelinesQueryVariables = Types.Exact<{
  pipelineConfigurationIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadLatestExecutionsForPipelinesQuery = { __typename: 'Query', readLatestExecutionsForPipelines: Array<{ __typename: 'PipelineExecutionResponseType', pipelineConfigurationId: string, pipelineExecutionId: string, name?: string, duration: number, status: Types.PipelineExecutionStatusEnum, errorMessage?: string, creationTimestamp?: any, updateTimestamp?: any, triggerSource:
      | { __typename: 'PipelineManualTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum }
      | { __typename: 'PipelineScheduledTriggerConfigurationType', type: Types.PipelineTriggerSourceTypeEnum, expression: string, expressionTimezone?: string, scheduleType?: Types.PipelineScheduleTypesEnum }
    , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, steps: Array<{ __typename: 'PipelineExecutionStepResponseType', type: Types.FeatureEnum, name?: string, status: Types.PipelineExecutionStatusEnum, allowFailure: boolean, targets: Array<{ __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: Types.PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> }> }> }> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const JobUserInfoFragmentDoc = new TypedDocumentString(`
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
    `, {"fragmentName":"JobUserInfo"});
export const GlobalBackupLifecycleSettingsFragmentDoc = new TypedDocumentString(`
    fragment GlobalBackupLifecycleSettings on GlobalBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  globalRetentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"GlobalBackupLifecycleSettings"});
export const DeviceBackupLifecycleSettingsFragmentDoc = new TypedDocumentString(`
    fragment DeviceBackupLifecycleSettings on DeviceBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  deviceId
  retentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"DeviceBackupLifecycleSettings"});
export const DeploymentRequestActivityFragmentDoc = new TypedDocumentString(`
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"DeploymentRequestActivity"});
export const DeploymentRequestFragmentDoc = new TypedDocumentString(`
    fragment DeploymentRequest on DeploymentRequestResponseType {
  __typename
  deploymentRequestId
  title
  description
  deviceId
  projectId
  projectVersionId
  featureOptions
  status
  approvalExpiresAt
  approvedByUserId
  approverUserIds
  executedByUserId
  jobId
  isExpired
  objectVersion
  creationUserId
  creationTimestamp
  updateTimestamp
  activities {
    __typename
    ...DeploymentRequestActivity
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  approvers {
    __typename
    ...JobUserInfo
  }
}
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"DeploymentRequest"});
export const PipelineConfigurationForSelectFragmentDoc = new TypedDocumentString(`
    fragment PipelineConfigurationForSelect on PipelineConfigurationResponseType {
  __typename
  pipelineConfigurationId
  name
  groupId
  objectVersion
  trigger {
    __typename
    ... on PipelineManualTriggerConfigurationType {
      __typename
      type
    }
    ... on PipelineScheduledTriggerConfigurationType {
      __typename
      type
      scheduleType
      expression
      expressionTimezone
    }
  }
}
    `, {"fragmentName":"PipelineConfigurationForSelect"});
export const TargetConfigurationFragmentDoc = new TypedDocumentString(`
    fragment TargetConfiguration on TargetConfigurationType {
  __typename
  deviceIds
  licenseIds
  projectIds
  projectVersionIds
  targetMetadata
}
    `, {"fragmentName":"TargetConfiguration"});
export const PipelineStepFragmentDoc = new TypedDocumentString(`
    fragment PipelineStep on PipelineStepConfigurationType {
  __typename
  name
  description
  allowFailure
  type
  targetConfiguration {
    __typename
    ...TargetConfiguration
  }
}
    fragment TargetConfiguration on TargetConfigurationType {
  __typename
  deviceIds
  licenseIds
  projectIds
  projectVersionIds
  targetMetadata
}`, {"fragmentName":"PipelineStep"});
export const PipelineConfigurationFragmentDoc = new TypedDocumentString(`
    fragment PipelineConfiguration on PipelineConfigurationResponseType {
  __typename
  description
  objectVersion
  name
  enabled
  pipelineConfigurationId
  steps {
    __typename
    ...PipelineStep
  }
  trigger {
    __typename
    ... on PipelineManualTriggerConfigurationType {
      __typename
      type
    }
    ... on PipelineScheduledTriggerConfigurationType {
      __typename
      type
      scheduleType
      expression
      expressionTimezone
    }
  }
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
  groupId
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment TargetConfiguration on TargetConfigurationType {
  __typename
  deviceIds
  licenseIds
  projectIds
  projectVersionIds
  targetMetadata
}
fragment PipelineStep on PipelineStepConfigurationType {
  __typename
  name
  description
  allowFailure
  type
  targetConfiguration {
    __typename
    ...TargetConfiguration
  }
}`, {"fragmentName":"PipelineConfiguration"});
export const TargetExecutionStatusFragmentDoc = new TypedDocumentString(`
    fragment TargetExecutionStatus on TargetExecutionStatusResponseType {
  __typename
  jobId
  status
  projectIds
  deviceIds
  licenseIds
}
    `, {"fragmentName":"TargetExecutionStatus"});
export const PipelineExecutionStepFragmentDoc = new TypedDocumentString(`
    fragment PipelineExecutionStep on PipelineExecutionStepResponseType {
  __typename
  type
  name
  status
  allowFailure
  targets {
    __typename
    ...TargetExecutionStatus
  }
}
    fragment TargetExecutionStatus on TargetExecutionStatusResponseType {
  __typename
  jobId
  status
  projectIds
  deviceIds
  licenseIds
}`, {"fragmentName":"PipelineExecutionStep"});
export const PipelineExecutionFragmentDoc = new TypedDocumentString(`
    fragment PipelineExecution on PipelineExecutionResponseType {
  __typename
  pipelineConfigurationId
  pipelineExecutionId
  name
  duration
  status
  errorMessage
  creationTimestamp
  updateTimestamp
  triggerSource {
    __typename
    ... on PipelineManualTriggerConfigurationType {
      __typename
      type
    }
    ... on PipelineScheduledTriggerConfigurationType {
      __typename
      type
      expression
      expressionTimezone
      scheduleType
    }
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
  steps {
    __typename
    ...PipelineExecutionStep
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment TargetExecutionStatus on TargetExecutionStatusResponseType {
  __typename
  jobId
  status
  projectIds
  deviceIds
  licenseIds
}
fragment PipelineExecutionStep on PipelineExecutionStepResponseType {
  __typename
  type
  name
  status
  allowFailure
  targets {
    __typename
    ...TargetExecutionStatus
  }
}`, {"fragmentName":"PipelineExecution"});
export const JobFragmentDoc = new TypedDocumentString(`
    fragment Job on JobResponseType {
  __typename
  jobId
  jobType
  status
  projectIds
  deviceIds
  licenseIds
  projectVersionIds
  objectVersion
  creationTimestamp
  updateTimestamp
  pipelineExecutionId
  pipelineConfigurationId
  startTimestamp
  duration
  finishedTimestamp
  errorMessage
  artifactsAvailable
  metaData
  source
  featureOptions
  creationUser {
    __typename
    ...JobUserInfo
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"Job"});
export const JobLogFragmentDoc = new TypedDocumentString(`
    fragment JobLog on JobLogType {
  __typename
  message
  timestamp
}
    `, {"fragmentName":"JobLog"});
export const CreateGlobalBackupLifecycleSettingsDocument = new TypedDocumentString(`
    mutation CreateGlobalBackupLifecycleSettings($globalRetentionLimit: Int!) {
  __typename
  createGlobalBackupLifecycleSettings(
    input: {globalRetentionLimit: $globalRetentionLimit}
  ) {
    __typename
    ...GlobalBackupLifecycleSettings
  }
}
    fragment GlobalBackupLifecycleSettings on GlobalBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  globalRetentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const UpdateGlobalBackupLifecycleSettingsDocument = new TypedDocumentString(`
    mutation UpdateGlobalBackupLifecycleSettings($globalRetentionLimit: Int!, $objectVersion: Int) {
  __typename
  updateGlobalBackupLifecycleSettings(
    input: {globalRetentionLimit: $globalRetentionLimit, objectVersion: $objectVersion}
  ) {
    __typename
    ...GlobalBackupLifecycleSettings
  }
}
    fragment GlobalBackupLifecycleSettings on GlobalBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  globalRetentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const DeleteGlobalBackupLifecycleSettingsDocument = new TypedDocumentString(`
    mutation DeleteGlobalBackupLifecycleSettings {
  __typename
  deleteGlobalBackupLifecycleSettings {
    __typename
    ...GlobalBackupLifecycleSettings
  }
}
    fragment GlobalBackupLifecycleSettings on GlobalBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  globalRetentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const CreateDeviceBackupLifecycleSettingsDocument = new TypedDocumentString(`
    mutation CreateDeviceBackupLifecycleSettings($deviceId: String!, $retentionLimit: Int!) {
  __typename
  createDeviceBackupLifecycleSettings(
    input: {deviceId: $deviceId, retentionLimit: $retentionLimit}
  ) {
    __typename
    ...DeviceBackupLifecycleSettings
  }
}
    fragment DeviceBackupLifecycleSettings on DeviceBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  deviceId
  retentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const UpdateDeviceBackupLifecycleSettingsDocument = new TypedDocumentString(`
    mutation UpdateDeviceBackupLifecycleSettings($deviceId: String!, $retentionLimit: Int!, $objectVersion: Int) {
  __typename
  updateDeviceBackupLifecycleSettings(
    input: {deviceId: $deviceId, retentionLimit: $retentionLimit, objectVersion: $objectVersion}
  ) {
    __typename
    ...DeviceBackupLifecycleSettings
  }
}
    fragment DeviceBackupLifecycleSettings on DeviceBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  deviceId
  retentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const DeleteDeviceBackupLifecycleSettingsDocument = new TypedDocumentString(`
    mutation DeleteDeviceBackupLifecycleSettings($deviceId: String!) {
  __typename
  deleteDeviceBackupLifecycleSettings(deviceId: $deviceId) {
    __typename
    ...DeviceBackupLifecycleSettings
  }
}
    fragment DeviceBackupLifecycleSettings on DeviceBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  deviceId
  retentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const BulkCreateDeviceBackupLifecycleSettingsDocument = new TypedDocumentString(`
    mutation BulkCreateDeviceBackupLifecycleSettings($input: BulkCreateDeviceBackupLifecycleSettingsInput!) {
  __typename
  bulkCreateDeviceBackupLifecycleSettings(input: $input) {
    __typename
    succeeded {
      __typename
      ...DeviceBackupLifecycleSettings
    }
    failedDeviceIds
  }
}
    fragment DeviceBackupLifecycleSettings on DeviceBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  deviceId
  retentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const BulkDeleteDeviceBackupLifecycleSettingsDocument = new TypedDocumentString(`
    mutation BulkDeleteDeviceBackupLifecycleSettings($input: BulkDeleteDeviceBackupLifecycleSettingsInput!) {
  __typename
  bulkDeleteDeviceBackupLifecycleSettings(input: $input)
}
    `);
export const ReadGlobalBackupLifecycleSettingsDocument = new TypedDocumentString(`
    query ReadGlobalBackupLifecycleSettings {
  __typename
  readGlobalBackupLifecycleSettings {
    __typename
    ...GlobalBackupLifecycleSettings
  }
}
    fragment GlobalBackupLifecycleSettings on GlobalBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  globalRetentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ReadDeviceBackupLifecycleSettingsDocument = new TypedDocumentString(`
    query ReadDeviceBackupLifecycleSettings($deviceId: String!) {
  __typename
  readDeviceBackupLifecycleSettings(deviceId: $deviceId) {
    __typename
    ...DeviceBackupLifecycleSettings
  }
}
    fragment DeviceBackupLifecycleSettings on DeviceBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  deviceId
  retentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ListDeviceBackupLifecycleSettingsDocument = new TypedDocumentString(`
    query ListDeviceBackupLifecycleSettings($pagination: PaginationInput) {
  __typename
  listDeviceBackupLifecycleSettings(pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...DeviceBackupLifecycleSettings
    }
  }
}
    fragment DeviceBackupLifecycleSettings on DeviceBackupLifecycleSettingsResponseType {
  __typename
  tenantId
  deviceId
  retentionLimit
  objectVersion
  creationUserId
  updateUserId
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const CreateDeploymentRequestDocument = new TypedDocumentString(`
    mutation CreateDeploymentRequest($input: CreateDeploymentRequestInput!) {
  __typename
  createDeploymentRequest(input: $input) {
    __typename
    ...DeploymentRequest
  }
}
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
fragment DeploymentRequest on DeploymentRequestResponseType {
  __typename
  deploymentRequestId
  title
  description
  deviceId
  projectId
  projectVersionId
  featureOptions
  status
  approvalExpiresAt
  approvedByUserId
  approverUserIds
  executedByUserId
  jobId
  isExpired
  objectVersion
  creationUserId
  creationTimestamp
  updateTimestamp
  activities {
    __typename
    ...DeploymentRequestActivity
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  approvers {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ApproveDeploymentRequestDocument = new TypedDocumentString(`
    mutation ApproveDeploymentRequest($deploymentRequestId: String!, $input: ApproveDeploymentRequestInput) {
  __typename
  approveDeploymentRequest(
    deploymentRequestId: $deploymentRequestId
    input: $input
  ) {
    __typename
    ...DeploymentRequest
  }
}
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
fragment DeploymentRequest on DeploymentRequestResponseType {
  __typename
  deploymentRequestId
  title
  description
  deviceId
  projectId
  projectVersionId
  featureOptions
  status
  approvalExpiresAt
  approvedByUserId
  approverUserIds
  executedByUserId
  jobId
  isExpired
  objectVersion
  creationUserId
  creationTimestamp
  updateTimestamp
  activities {
    __typename
    ...DeploymentRequestActivity
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  approvers {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const DenyDeploymentRequestDocument = new TypedDocumentString(`
    mutation DenyDeploymentRequest($deploymentRequestId: String!, $comment: String) {
  __typename
  denyDeploymentRequest(
    deploymentRequestId: $deploymentRequestId
    comment: $comment
  ) {
    __typename
    ...DeploymentRequest
  }
}
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
fragment DeploymentRequest on DeploymentRequestResponseType {
  __typename
  deploymentRequestId
  title
  description
  deviceId
  projectId
  projectVersionId
  featureOptions
  status
  approvalExpiresAt
  approvedByUserId
  approverUserIds
  executedByUserId
  jobId
  isExpired
  objectVersion
  creationUserId
  creationTimestamp
  updateTimestamp
  activities {
    __typename
    ...DeploymentRequestActivity
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  approvers {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const CancelDeploymentRequestDocument = new TypedDocumentString(`
    mutation CancelDeploymentRequest($deploymentRequestId: String!, $comment: String) {
  __typename
  cancelDeploymentRequest(
    deploymentRequestId: $deploymentRequestId
    comment: $comment
  ) {
    __typename
    ...DeploymentRequest
  }
}
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
fragment DeploymentRequest on DeploymentRequestResponseType {
  __typename
  deploymentRequestId
  title
  description
  deviceId
  projectId
  projectVersionId
  featureOptions
  status
  approvalExpiresAt
  approvedByUserId
  approverUserIds
  executedByUserId
  jobId
  isExpired
  objectVersion
  creationUserId
  creationTimestamp
  updateTimestamp
  activities {
    __typename
    ...DeploymentRequestActivity
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  approvers {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ExecuteDeploymentRequestDocument = new TypedDocumentString(`
    mutation ExecuteDeploymentRequest($deploymentRequestId: String!) {
  __typename
  executeDeploymentRequest(deploymentRequestId: $deploymentRequestId) {
    __typename
    ...DeploymentRequest
  }
}
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
fragment DeploymentRequest on DeploymentRequestResponseType {
  __typename
  deploymentRequestId
  title
  description
  deviceId
  projectId
  projectVersionId
  featureOptions
  status
  approvalExpiresAt
  approvedByUserId
  approverUserIds
  executedByUserId
  jobId
  isExpired
  objectVersion
  creationUserId
  creationTimestamp
  updateTimestamp
  activities {
    __typename
    ...DeploymentRequestActivity
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  approvers {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const DeleteDeploymentRequestDocument = new TypedDocumentString(`
    mutation DeleteDeploymentRequest($deploymentRequestId: String!) {
  __typename
  deleteDeploymentRequest(deploymentRequestId: $deploymentRequestId) {
    __typename
    ...DeploymentRequest
  }
}
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
fragment DeploymentRequest on DeploymentRequestResponseType {
  __typename
  deploymentRequestId
  title
  description
  deviceId
  projectId
  projectVersionId
  featureOptions
  status
  approvalExpiresAt
  approvedByUserId
  approverUserIds
  executedByUserId
  jobId
  isExpired
  objectVersion
  creationUserId
  creationTimestamp
  updateTimestamp
  activities {
    __typename
    ...DeploymentRequestActivity
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  approvers {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const UpdateDeploymentRequestApproversDocument = new TypedDocumentString(`
    mutation UpdateDeploymentRequestApprovers($deploymentRequestId: String!, $input: UpdateDeploymentRequestApproversInput!) {
  __typename
  updateDeploymentRequestApprovers(
    deploymentRequestId: $deploymentRequestId
    input: $input
  ) {
    __typename
    ...DeploymentRequest
  }
}
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
fragment DeploymentRequest on DeploymentRequestResponseType {
  __typename
  deploymentRequestId
  title
  description
  deviceId
  projectId
  projectVersionId
  featureOptions
  status
  approvalExpiresAt
  approvedByUserId
  approverUserIds
  executedByUserId
  jobId
  isExpired
  objectVersion
  creationUserId
  creationTimestamp
  updateTimestamp
  activities {
    __typename
    ...DeploymentRequestActivity
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  approvers {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ReadDeploymentRequestDocument = new TypedDocumentString(`
    query ReadDeploymentRequest($deploymentRequestId: String!) {
  __typename
  readDeploymentRequest(deploymentRequestId: $deploymentRequestId) {
    __typename
    ...DeploymentRequest
  }
}
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
fragment DeploymentRequest on DeploymentRequestResponseType {
  __typename
  deploymentRequestId
  title
  description
  deviceId
  projectId
  projectVersionId
  featureOptions
  status
  approvalExpiresAt
  approvedByUserId
  approverUserIds
  executedByUserId
  jobId
  isExpired
  objectVersion
  creationUserId
  creationTimestamp
  updateTimestamp
  activities {
    __typename
    ...DeploymentRequestActivity
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  approvers {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ReadDeploymentRequestsDocument = new TypedDocumentString(`
    query ReadDeploymentRequests($filter: DeploymentRequestFilterInput, $pagination: PaginationInput) {
  __typename
  readDeploymentRequests(filter: $filter, pagination: $pagination) {
    __typename
    itemCount
    pages
    items {
      __typename
      ...DeploymentRequest
    }
  }
}
    fragment DeploymentRequestActivity on DeploymentRequestActivityType {
  __typename
  action
  userId
  user {
    __typename
    ...JobUserInfo
  }
  timestamp
  comment
  subjectUserId
  subjectUser {
    __typename
    ...JobUserInfo
  }
}
fragment DeploymentRequest on DeploymentRequestResponseType {
  __typename
  deploymentRequestId
  title
  description
  deviceId
  projectId
  projectVersionId
  featureOptions
  status
  approvalExpiresAt
  approvedByUserId
  approverUserIds
  executedByUserId
  jobId
  isExpired
  objectVersion
  creationUserId
  creationTimestamp
  updateTimestamp
  activities {
    __typename
    ...DeploymentRequestActivity
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  approvers {
    __typename
    ...JobUserInfo
  }
}
fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ReadEligibleDeploymentApproversDocument = new TypedDocumentString(`
    query ReadEligibleDeploymentApprovers($deviceId: String!) {
  __typename
  readEligibleDeploymentApprovers(deviceId: $deviceId) {
    __typename
    ...JobUserInfo
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const CreatePipelineConfigurationDocument = new TypedDocumentString(`
    mutation CreatePipelineConfiguration($pipelineConfiguration: CreatePipelineConfigurationInput!) {
  __typename
  createPipelineConfiguration(pipelineConfiguration: $pipelineConfiguration) {
    __typename
    pipelineConfigurationId
  }
}
    `);
export const UpdatePipelineConfigurationDocument = new TypedDocumentString(`
    mutation UpdatePipelineConfiguration($pipelineConfigurationId: String!, $input: UpdatePipelineConfigurationInput!) {
  __typename
  updatePipelineConfiguration(
    pipelineConfigurationId: $pipelineConfigurationId
    input: $input
  ) {
    __typename
    pipelineConfigurationId
  }
}
    `);
export const DeletePipelineConfigurationDocument = new TypedDocumentString(`
    mutation DeletePipelineConfiguration($pipelineConfigurationId: String!) {
  __typename
  deletePipelineConfiguration(pipelineConfigurationId: $pipelineConfigurationId) {
    __typename
    pipelineConfigurationId
  }
}
    `);
export const TriggerPipelineExecutionDocument = new TypedDocumentString(`
    mutation TriggerPipelineExecution($pipelineConfigurationId: String!) {
  __typename
  triggerPipelineExecution(pipelineConfigurationId: $pipelineConfigurationId) {
    __typename
    pipelineExecutionId
  }
}
    `);
export const CreateConversionDocument = new TypedDocumentString(`
    mutation CreateConversion($projectId: String!, $versionId: String!) {
  __typename
  createJob(
    job: {projectIds: [$projectId], projectVersionIds: [$versionId], jobType: PROJECT_CONVERT}
  ) {
    __typename
    jobId
  }
}
    `);
export const DeleteJobDocument = new TypedDocumentString(`
    mutation DeleteJob($jobId: String!) {
  __typename
  deleteJob(jobId: $jobId) {
    __typename
    jobId
    deviceIds
  }
}
    `);
export const DeletePipelineExecutionDocument = new TypedDocumentString(`
    mutation DeletePipelineExecution($pipelineExecutionId: String!) {
  __typename
  deletePipelineExecution(pipelineExecutionId: $pipelineExecutionId) {
    __typename
    pipelineConfigurationId
    pipelineExecutionId
  }
}
    `);
export const DownloadArtifactsForJobDocument = new TypedDocumentString(`
    mutation DownloadArtifactsForJob($jobId: String!) {
  __typename
  downloadArtifactsForJob(jobId: $jobId) {
    __typename
    channel
    message
  }
}
    `);
export const CreateDeviceJobDocument = new TypedDocumentString(`
    mutation CreateDeviceJob($deviceId: String!, $jobType: FeatureEnum!, $projectIds: [String!], $projectVersionIds: [String!], $featureOptions: JSON, $metaData: JSON) {
  __typename
  createJob(
    job: {source: WEB_CONSOLE, deviceIds: [$deviceId], jobType: $jobType, projectIds: $projectIds, projectVersionIds: $projectVersionIds, featureOptions: $featureOptions, metaData: $metaData}
  ) {
    __typename
    ...Job
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Job on JobResponseType {
  __typename
  jobId
  jobType
  status
  projectIds
  deviceIds
  licenseIds
  projectVersionIds
  objectVersion
  creationTimestamp
  updateTimestamp
  pipelineExecutionId
  pipelineConfigurationId
  startTimestamp
  duration
  finishedTimestamp
  errorMessage
  artifactsAvailable
  metaData
  source
  featureOptions
  creationUser {
    __typename
    ...JobUserInfo
  }
}`);
export const CreateJobDocument = new TypedDocumentString(`
    mutation CreateJob($jobType: FeatureEnum!, $deviceIds: [String!], $projectIds: [String!], $projectVersionIds: [String!], $featureOptions: JSON, $metaData: JSON) {
  __typename
  createJob(
    job: {source: WEB_CONSOLE, jobType: $jobType, deviceIds: $deviceIds, projectIds: $projectIds, projectVersionIds: $projectVersionIds, featureOptions: $featureOptions, metaData: $metaData}
  ) {
    __typename
    ...Job
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Job on JobResponseType {
  __typename
  jobId
  jobType
  status
  projectIds
  deviceIds
  licenseIds
  projectVersionIds
  objectVersion
  creationTimestamp
  updateTimestamp
  pipelineExecutionId
  pipelineConfigurationId
  startTimestamp
  duration
  finishedTimestamp
  errorMessage
  artifactsAvailable
  metaData
  source
  featureOptions
  creationUser {
    __typename
    ...JobUserInfo
  }
}`);
export const ReadAllPipelinesDocument = new TypedDocumentString(`
    query ReadAllPipelines($filter: PipelineConfigurationFilterInput, $pagination: PaginationInput) {
  __typename
  readAllPipelineConfigurations(filter: $filter, pagination: $pagination) {
    __typename
    itemCount
    pages
    items {
      __typename
      ...PipelineConfiguration
    }
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment TargetConfiguration on TargetConfigurationType {
  __typename
  deviceIds
  licenseIds
  projectIds
  projectVersionIds
  targetMetadata
}
fragment PipelineStep on PipelineStepConfigurationType {
  __typename
  name
  description
  allowFailure
  type
  targetConfiguration {
    __typename
    ...TargetConfiguration
  }
}
fragment PipelineConfiguration on PipelineConfigurationResponseType {
  __typename
  description
  objectVersion
  name
  enabled
  pipelineConfigurationId
  steps {
    __typename
    ...PipelineStep
  }
  trigger {
    __typename
    ... on PipelineManualTriggerConfigurationType {
      __typename
      type
    }
    ... on PipelineScheduledTriggerConfigurationType {
      __typename
      type
      scheduleType
      expression
      expressionTimezone
    }
  }
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
  groupId
}`);
export const ReadPipelinesForSelectDocument = new TypedDocumentString(`
    query ReadPipelinesForSelect($filter: PipelineConfigurationFilterInput) {
  __typename
  readAllPipelineConfigurations(filter: $filter) {
    __typename
    items {
      __typename
      ...PipelineConfigurationForSelect
    }
  }
}
    fragment PipelineConfigurationForSelect on PipelineConfigurationResponseType {
  __typename
  pipelineConfigurationId
  name
  groupId
  objectVersion
  trigger {
    __typename
    ... on PipelineManualTriggerConfigurationType {
      __typename
      type
    }
    ... on PipelineScheduledTriggerConfigurationType {
      __typename
      type
      scheduleType
      expression
      expressionTimezone
    }
  }
}`);
export const ReadPipelineExecutionsForPipelineDocument = new TypedDocumentString(`
    query ReadPipelineExecutionsForPipeline($pipelineConfigurationId: String!, $filter: PipelineExecutionFilterInput, $pagination: PaginationInput) {
  __typename
  readAllPipelineExecutionsForConfiguration(
    pipelineConfigurationId: $pipelineConfigurationId
    filter: $filter
    pagination: $pagination
  ) {
    __typename
    itemCount
    pages
    items {
      __typename
      ...PipelineExecution
    }
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment TargetExecutionStatus on TargetExecutionStatusResponseType {
  __typename
  jobId
  status
  projectIds
  deviceIds
  licenseIds
}
fragment PipelineExecutionStep on PipelineExecutionStepResponseType {
  __typename
  type
  name
  status
  allowFailure
  targets {
    __typename
    ...TargetExecutionStatus
  }
}
fragment PipelineExecution on PipelineExecutionResponseType {
  __typename
  pipelineConfigurationId
  pipelineExecutionId
  name
  duration
  status
  errorMessage
  creationTimestamp
  updateTimestamp
  triggerSource {
    __typename
    ... on PipelineManualTriggerConfigurationType {
      __typename
      type
    }
    ... on PipelineScheduledTriggerConfigurationType {
      __typename
      type
      expression
      expressionTimezone
      scheduleType
    }
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
  steps {
    __typename
    ...PipelineExecutionStep
  }
}`);
export const ReadPipelineDocument = new TypedDocumentString(`
    query ReadPipeline($pipelineConfigurationId: String!) {
  __typename
  readPipelineConfiguration(pipelineConfigurationId: $pipelineConfigurationId) {
    __typename
    ...PipelineConfiguration
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment TargetConfiguration on TargetConfigurationType {
  __typename
  deviceIds
  licenseIds
  projectIds
  projectVersionIds
  targetMetadata
}
fragment PipelineStep on PipelineStepConfigurationType {
  __typename
  name
  description
  allowFailure
  type
  targetConfiguration {
    __typename
    ...TargetConfiguration
  }
}
fragment PipelineConfiguration on PipelineConfigurationResponseType {
  __typename
  description
  objectVersion
  name
  enabled
  pipelineConfigurationId
  steps {
    __typename
    ...PipelineStep
  }
  trigger {
    __typename
    ... on PipelineManualTriggerConfigurationType {
      __typename
      type
    }
    ... on PipelineScheduledTriggerConfigurationType {
      __typename
      type
      scheduleType
      expression
      expressionTimezone
    }
  }
  creationTimestamp
  updateTimestamp
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
  groupId
}`);
export const ReadVersionOriginJobsDocument = new TypedDocumentString(`
    query ReadVersionOriginJobs($projectIds: [String!]!, $jobTypes: [FeatureEnum!]!, $filter: JobFilterInput, $pagination: PaginationInput) {
  __typename
  readJobsByProjectIds(
    projectIds: $projectIds
    jobTypes: $jobTypes
    filter: $filter
    pagination: $pagination
  ) {
    __typename
    items {
      __typename
      jobId
      jobType
      metaData
      createdProjectVersionId
      pipelineExecutionId
      pipelineConfigurationId
    }
  }
}
    `);
export const ReadAllJobsDocument = new TypedDocumentString(`
    query ReadAllJobs($filter: JobFilterInput, $pagination: PaginationInput) {
  __typename
  readAllJobs(filter: $filter, pagination: $pagination) {
    __typename
    itemCount
    items {
      __typename
      ...Job
    }
    pages
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Job on JobResponseType {
  __typename
  jobId
  jobType
  status
  projectIds
  deviceIds
  licenseIds
  projectVersionIds
  objectVersion
  creationTimestamp
  updateTimestamp
  pipelineExecutionId
  pipelineConfigurationId
  startTimestamp
  duration
  finishedTimestamp
  errorMessage
  artifactsAvailable
  metaData
  source
  featureOptions
  creationUser {
    __typename
    ...JobUserInfo
  }
}`);
export const ReadJobsByDeviceIdsDocument = new TypedDocumentString(`
    query ReadJobsByDeviceIds($deviceIds: [String!]!, $jobTypes: [FeatureEnum!]!, $filter: JobFilterInput, $pagination: PaginationInput) {
  __typename
  readJobsByDeviceIds(
    deviceIds: $deviceIds
    jobTypes: $jobTypes
    filter: $filter
    pagination: $pagination
  ) {
    __typename
    itemCount
    items {
      __typename
      ...Job
    }
    pages
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Job on JobResponseType {
  __typename
  jobId
  jobType
  status
  projectIds
  deviceIds
  licenseIds
  projectVersionIds
  objectVersion
  creationTimestamp
  updateTimestamp
  pipelineExecutionId
  pipelineConfigurationId
  startTimestamp
  duration
  finishedTimestamp
  errorMessage
  artifactsAvailable
  metaData
  source
  featureOptions
  creationUser {
    __typename
    ...JobUserInfo
  }
}`);
export const ReadJobsByProjectIdDocument = new TypedDocumentString(`
    query ReadJobsByProjectId($projectId: String!, $jobTypes: [FeatureEnum!]!, $filter: JobFilterInput, $pagination: PaginationInput) {
  __typename
  readJobsByProjectId(
    projectId: $projectId
    jobTypes: $jobTypes
    filter: $filter
    pagination: $pagination
  ) {
    __typename
    itemCount
    items {
      __typename
      ...Job
    }
    pages
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Job on JobResponseType {
  __typename
  jobId
  jobType
  status
  projectIds
  deviceIds
  licenseIds
  projectVersionIds
  objectVersion
  creationTimestamp
  updateTimestamp
  pipelineExecutionId
  pipelineConfigurationId
  startTimestamp
  duration
  finishedTimestamp
  errorMessage
  artifactsAvailable
  metaData
  source
  featureOptions
  creationUser {
    __typename
    ...JobUserInfo
  }
}`);
export const ReadJobsByProjectIdsDocument = new TypedDocumentString(`
    query ReadJobsByProjectIds($projectIds: [String!]!, $jobTypes: [FeatureEnum!]!, $filter: JobFilterInput, $pagination: PaginationInput) {
  __typename
  readJobsByProjectIds(
    projectIds: $projectIds
    jobTypes: $jobTypes
    filter: $filter
    pagination: $pagination
  ) {
    __typename
    itemCount
    items {
      __typename
      ...Job
    }
    pages
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Job on JobResponseType {
  __typename
  jobId
  jobType
  status
  projectIds
  deviceIds
  licenseIds
  projectVersionIds
  objectVersion
  creationTimestamp
  updateTimestamp
  pipelineExecutionId
  pipelineConfigurationId
  startTimestamp
  duration
  finishedTimestamp
  errorMessage
  artifactsAvailable
  metaData
  source
  featureOptions
  creationUser {
    __typename
    ...JobUserInfo
  }
}`);
export const ReadLatestJobsByProjectIdsDocument = new TypedDocumentString(`
    query ReadLatestJobsByProjectIds($projectIds: [String!]!, $jobTypes: [FeatureEnum!]!, $filter: JobFilterInput, $limitPerProject: Int!) {
  __typename
  readLatestJobsByProjectIds(
    projectIds: $projectIds
    jobTypes: $jobTypes
    filter: $filter
    limitPerProject: $limitPerProject
  ) {
    __typename
    ...Job
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Job on JobResponseType {
  __typename
  jobId
  jobType
  status
  projectIds
  deviceIds
  licenseIds
  projectVersionIds
  objectVersion
  creationTimestamp
  updateTimestamp
  pipelineExecutionId
  pipelineConfigurationId
  startTimestamp
  duration
  finishedTimestamp
  errorMessage
  artifactsAvailable
  metaData
  source
  featureOptions
  creationUser {
    __typename
    ...JobUserInfo
  }
}`);
export const ReadPipelineExecutionDocument = new TypedDocumentString(`
    query ReadPipelineExecution($pipelineExecutionId: String!) {
  __typename
  readPipelineExecution(pipelineExecutionId: $pipelineExecutionId) {
    __typename
    ...PipelineExecution
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment TargetExecutionStatus on TargetExecutionStatusResponseType {
  __typename
  jobId
  status
  projectIds
  deviceIds
  licenseIds
}
fragment PipelineExecutionStep on PipelineExecutionStepResponseType {
  __typename
  type
  name
  status
  allowFailure
  targets {
    __typename
    ...TargetExecutionStatus
  }
}
fragment PipelineExecution on PipelineExecutionResponseType {
  __typename
  pipelineConfigurationId
  pipelineExecutionId
  name
  duration
  status
  errorMessage
  creationTimestamp
  updateTimestamp
  triggerSource {
    __typename
    ... on PipelineManualTriggerConfigurationType {
      __typename
      type
    }
    ... on PipelineScheduledTriggerConfigurationType {
      __typename
      type
      expression
      expressionTimezone
      scheduleType
    }
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
  steps {
    __typename
    ...PipelineExecutionStep
  }
}`);
export const ReadJobDocument = new TypedDocumentString(`
    query ReadJob($jobId: String!) {
  __typename
  readJob(jobId: $jobId) {
    __typename
    ...Job
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Job on JobResponseType {
  __typename
  jobId
  jobType
  status
  projectIds
  deviceIds
  licenseIds
  projectVersionIds
  objectVersion
  creationTimestamp
  updateTimestamp
  pipelineExecutionId
  pipelineConfigurationId
  startTimestamp
  duration
  finishedTimestamp
  errorMessage
  artifactsAvailable
  metaData
  source
  featureOptions
  creationUser {
    __typename
    ...JobUserInfo
  }
}`);
export const ReadJobLogsDocument = new TypedDocumentString(`
    query ReadJobLogs($jobId: String!, $filter: JobLogsFilterInput) {
  __typename
  readJobLogs(jobId: $jobId, filter: $filter) {
    __typename
    logs {
      __typename
      ...JobLog
    }
    nextToken
  }
}
    fragment JobLog on JobLogType {
  __typename
  message
  timestamp
}`);
export const ReadPipelineNamesForPolicyRowDocument = new TypedDocumentString(`
    query ReadPipelineNamesForPolicyRow($filter: PipelineConfigurationFilterInput, $pagination: PaginationInput) {
  __typename
  readAllPipelineConfigurations(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      name
      pipelineConfigurationId
    }
  }
}
    `);
export const ReadGroupedPipelinesCountDocument = new TypedDocumentString(`
    query ReadGroupedPipelinesCount($groupId: String!) {
  __typename
  readAllPipelineConfigurations(filter: {groupId: {contains: $groupId}}) {
    __typename
    itemCount
  }
}
    `);
export const ReadUngroupedPipelinesCountDocument = new TypedDocumentString(`
    query ReadUngroupedPipelinesCount {
  __typename
  readAllPipelineConfigurations(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
}
    `);
export const ReadGroupedPipelineCountsDocument = new TypedDocumentString(`
    query ReadGroupedPipelineCounts($groupIds: [String!]!) {
  __typename
  readGroupedPipelineCounts(groupIds: $groupIds) {
    __typename
    groupId
    count
  }
}
    `);
export const ReadLatestExecutionsForPipelinesDocument = new TypedDocumentString(`
    query ReadLatestExecutionsForPipelines($pipelineConfigurationIds: [String!]!) {
  __typename
  readLatestExecutionsForPipelines(
    pipelineConfigurationIds: $pipelineConfigurationIds
  ) {
    __typename
    ...PipelineExecution
  }
}
    fragment JobUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment TargetExecutionStatus on TargetExecutionStatusResponseType {
  __typename
  jobId
  status
  projectIds
  deviceIds
  licenseIds
}
fragment PipelineExecutionStep on PipelineExecutionStepResponseType {
  __typename
  type
  name
  status
  allowFailure
  targets {
    __typename
    ...TargetExecutionStatus
  }
}
fragment PipelineExecution on PipelineExecutionResponseType {
  __typename
  pipelineConfigurationId
  pipelineExecutionId
  name
  duration
  status
  errorMessage
  creationTimestamp
  updateTimestamp
  triggerSource {
    __typename
    ... on PipelineManualTriggerConfigurationType {
      __typename
      type
    }
    ... on PipelineScheduledTriggerConfigurationType {
      __typename
      type
      expression
      expressionTimezone
      scheduleType
    }
  }
  creationUser {
    __typename
    ...JobUserInfo
  }
  updateUser {
    __typename
    ...JobUserInfo
  }
  steps {
    __typename
    ...PipelineExecutionStep
  }
}`);

const injectedRtkApi = baseJobsApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    CreateGlobalBackupLifecycleSettings: build.mutation<Types.CreateGlobalBackupLifecycleSettingsMutation, Types.CreateGlobalBackupLifecycleSettingsMutationVariables>({
      query: (variables) => ({ document: CreateGlobalBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    UpdateGlobalBackupLifecycleSettings: build.mutation<Types.UpdateGlobalBackupLifecycleSettingsMutation, Types.UpdateGlobalBackupLifecycleSettingsMutationVariables>({
      query: (variables) => ({ document: UpdateGlobalBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    DeleteGlobalBackupLifecycleSettings: build.mutation<Types.DeleteGlobalBackupLifecycleSettingsMutation, Types.DeleteGlobalBackupLifecycleSettingsMutationVariables | void>({
      query: (variables) => ({ document: DeleteGlobalBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    CreateDeviceBackupLifecycleSettings: build.mutation<Types.CreateDeviceBackupLifecycleSettingsMutation, Types.CreateDeviceBackupLifecycleSettingsMutationVariables>({
      query: (variables) => ({ document: CreateDeviceBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    UpdateDeviceBackupLifecycleSettings: build.mutation<Types.UpdateDeviceBackupLifecycleSettingsMutation, Types.UpdateDeviceBackupLifecycleSettingsMutationVariables>({
      query: (variables) => ({ document: UpdateDeviceBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    DeleteDeviceBackupLifecycleSettings: build.mutation<Types.DeleteDeviceBackupLifecycleSettingsMutation, Types.DeleteDeviceBackupLifecycleSettingsMutationVariables>({
      query: (variables) => ({ document: DeleteDeviceBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    BulkCreateDeviceBackupLifecycleSettings: build.mutation<Types.BulkCreateDeviceBackupLifecycleSettingsMutation, Types.BulkCreateDeviceBackupLifecycleSettingsMutationVariables>({
      query: (variables) => ({ document: BulkCreateDeviceBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    BulkDeleteDeviceBackupLifecycleSettings: build.mutation<Types.BulkDeleteDeviceBackupLifecycleSettingsMutation, Types.BulkDeleteDeviceBackupLifecycleSettingsMutationVariables>({
      query: (variables) => ({ document: BulkDeleteDeviceBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    ReadGlobalBackupLifecycleSettings: build.query<Types.ReadGlobalBackupLifecycleSettingsQuery, Types.ReadGlobalBackupLifecycleSettingsQueryVariables | void>({
      query: (variables) => ({ document: ReadGlobalBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    ReadDeviceBackupLifecycleSettings: build.query<Types.ReadDeviceBackupLifecycleSettingsQuery, Types.ReadDeviceBackupLifecycleSettingsQueryVariables>({
      query: (variables) => ({ document: ReadDeviceBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    ListDeviceBackupLifecycleSettings: build.query<Types.ListDeviceBackupLifecycleSettingsQuery, Types.ListDeviceBackupLifecycleSettingsQueryVariables | void>({
      query: (variables) => ({ document: ListDeviceBackupLifecycleSettingsDocument as unknown as string, variables })
    }),
    CreateDeploymentRequest: build.mutation<Types.CreateDeploymentRequestMutation, Types.CreateDeploymentRequestMutationVariables>({
      query: (variables) => ({ document: CreateDeploymentRequestDocument as unknown as string, variables })
    }),
    ApproveDeploymentRequest: build.mutation<Types.ApproveDeploymentRequestMutation, Types.ApproveDeploymentRequestMutationVariables>({
      query: (variables) => ({ document: ApproveDeploymentRequestDocument as unknown as string, variables })
    }),
    DenyDeploymentRequest: build.mutation<Types.DenyDeploymentRequestMutation, Types.DenyDeploymentRequestMutationVariables>({
      query: (variables) => ({ document: DenyDeploymentRequestDocument as unknown as string, variables })
    }),
    CancelDeploymentRequest: build.mutation<Types.CancelDeploymentRequestMutation, Types.CancelDeploymentRequestMutationVariables>({
      query: (variables) => ({ document: CancelDeploymentRequestDocument as unknown as string, variables })
    }),
    ExecuteDeploymentRequest: build.mutation<Types.ExecuteDeploymentRequestMutation, Types.ExecuteDeploymentRequestMutationVariables>({
      query: (variables) => ({ document: ExecuteDeploymentRequestDocument as unknown as string, variables })
    }),
    DeleteDeploymentRequest: build.mutation<Types.DeleteDeploymentRequestMutation, Types.DeleteDeploymentRequestMutationVariables>({
      query: (variables) => ({ document: DeleteDeploymentRequestDocument as unknown as string, variables })
    }),
    UpdateDeploymentRequestApprovers: build.mutation<Types.UpdateDeploymentRequestApproversMutation, Types.UpdateDeploymentRequestApproversMutationVariables>({
      query: (variables) => ({ document: UpdateDeploymentRequestApproversDocument as unknown as string, variables })
    }),
    ReadDeploymentRequest: build.query<Types.ReadDeploymentRequestQuery, Types.ReadDeploymentRequestQueryVariables>({
      query: (variables) => ({ document: ReadDeploymentRequestDocument as unknown as string, variables })
    }),
    ReadDeploymentRequests: build.query<Types.ReadDeploymentRequestsQuery, Types.ReadDeploymentRequestsQueryVariables | void>({
      query: (variables) => ({ document: ReadDeploymentRequestsDocument as unknown as string, variables })
    }),
    ReadEligibleDeploymentApprovers: build.query<Types.ReadEligibleDeploymentApproversQuery, Types.ReadEligibleDeploymentApproversQueryVariables>({
      query: (variables) => ({ document: ReadEligibleDeploymentApproversDocument as unknown as string, variables })
    }),
    CreatePipelineConfiguration: build.mutation<Types.CreatePipelineConfigurationMutation, Types.CreatePipelineConfigurationMutationVariables>({
      query: (variables) => ({ document: CreatePipelineConfigurationDocument as unknown as string, variables })
    }),
    UpdatePipelineConfiguration: build.mutation<Types.UpdatePipelineConfigurationMutation, Types.UpdatePipelineConfigurationMutationVariables>({
      query: (variables) => ({ document: UpdatePipelineConfigurationDocument as unknown as string, variables })
    }),
    DeletePipelineConfiguration: build.mutation<Types.DeletePipelineConfigurationMutation, Types.DeletePipelineConfigurationMutationVariables>({
      query: (variables) => ({ document: DeletePipelineConfigurationDocument as unknown as string, variables })
    }),
    TriggerPipelineExecution: build.mutation<Types.TriggerPipelineExecutionMutation, Types.TriggerPipelineExecutionMutationVariables>({
      query: (variables) => ({ document: TriggerPipelineExecutionDocument as unknown as string, variables })
    }),
    CreateConversion: build.mutation<Types.CreateConversionMutation, Types.CreateConversionMutationVariables>({
      query: (variables) => ({ document: CreateConversionDocument as unknown as string, variables })
    }),
    DeleteJob: build.mutation<Types.DeleteJobMutation, Types.DeleteJobMutationVariables>({
      query: (variables) => ({ document: DeleteJobDocument as unknown as string, variables })
    }),
    DeletePipelineExecution: build.mutation<Types.DeletePipelineExecutionMutation, Types.DeletePipelineExecutionMutationVariables>({
      query: (variables) => ({ document: DeletePipelineExecutionDocument as unknown as string, variables })
    }),
    DownloadArtifactsForJob: build.mutation<Types.DownloadArtifactsForJobMutation, Types.DownloadArtifactsForJobMutationVariables>({
      query: (variables) => ({ document: DownloadArtifactsForJobDocument as unknown as string, variables })
    }),
    CreateDeviceJob: build.mutation<Types.CreateDeviceJobMutation, Types.CreateDeviceJobMutationVariables>({
      query: (variables) => ({ document: CreateDeviceJobDocument as unknown as string, variables })
    }),
    CreateJob: build.mutation<Types.CreateJobMutation, Types.CreateJobMutationVariables>({
      query: (variables) => ({ document: CreateJobDocument as unknown as string, variables })
    }),
    ReadAllPipelines: build.query<Types.ReadAllPipelinesQuery, Types.ReadAllPipelinesQueryVariables | void>({
      query: (variables) => ({ document: ReadAllPipelinesDocument as unknown as string, variables })
    }),
    ReadPipelinesForSelect: build.query<Types.ReadPipelinesForSelectQuery, Types.ReadPipelinesForSelectQueryVariables | void>({
      query: (variables) => ({ document: ReadPipelinesForSelectDocument as unknown as string, variables })
    }),
    ReadPipelineExecutionsForPipeline: build.query<Types.ReadPipelineExecutionsForPipelineQuery, Types.ReadPipelineExecutionsForPipelineQueryVariables>({
      query: (variables) => ({ document: ReadPipelineExecutionsForPipelineDocument as unknown as string, variables })
    }),
    ReadPipeline: build.query<Types.ReadPipelineQuery, Types.ReadPipelineQueryVariables>({
      query: (variables) => ({ document: ReadPipelineDocument as unknown as string, variables })
    }),
    ReadVersionOriginJobs: build.query<Types.ReadVersionOriginJobsQuery, Types.ReadVersionOriginJobsQueryVariables>({
      query: (variables) => ({ document: ReadVersionOriginJobsDocument as unknown as string, variables })
    }),
    ReadAllJobs: build.query<Types.ReadAllJobsQuery, Types.ReadAllJobsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllJobsDocument as unknown as string, variables })
    }),
    ReadJobsByDeviceIds: build.query<Types.ReadJobsByDeviceIdsQuery, Types.ReadJobsByDeviceIdsQueryVariables>({
      query: (variables) => ({ document: ReadJobsByDeviceIdsDocument as unknown as string, variables })
    }),
    ReadJobsByProjectId: build.query<Types.ReadJobsByProjectIdQuery, Types.ReadJobsByProjectIdQueryVariables>({
      query: (variables) => ({ document: ReadJobsByProjectIdDocument as unknown as string, variables })
    }),
    ReadJobsByProjectIds: build.query<Types.ReadJobsByProjectIdsQuery, Types.ReadJobsByProjectIdsQueryVariables>({
      query: (variables) => ({ document: ReadJobsByProjectIdsDocument as unknown as string, variables })
    }),
    ReadLatestJobsByProjectIds: build.query<Types.ReadLatestJobsByProjectIdsQuery, Types.ReadLatestJobsByProjectIdsQueryVariables>({
      query: (variables) => ({ document: ReadLatestJobsByProjectIdsDocument as unknown as string, variables })
    }),
    ReadPipelineExecution: build.query<Types.ReadPipelineExecutionQuery, Types.ReadPipelineExecutionQueryVariables>({
      query: (variables) => ({ document: ReadPipelineExecutionDocument as unknown as string, variables })
    }),
    ReadJob: build.query<Types.ReadJobQuery, Types.ReadJobQueryVariables>({
      query: (variables) => ({ document: ReadJobDocument as unknown as string, variables })
    }),
    ReadJobLogs: build.query<Types.ReadJobLogsQuery, Types.ReadJobLogsQueryVariables>({
      query: (variables) => ({ document: ReadJobLogsDocument as unknown as string, variables })
    }),
    ReadPipelineNamesForPolicyRow: build.query<Types.ReadPipelineNamesForPolicyRowQuery, Types.ReadPipelineNamesForPolicyRowQueryVariables | void>({
      query: (variables) => ({ document: ReadPipelineNamesForPolicyRowDocument as unknown as string, variables })
    }),
    ReadGroupedPipelinesCount: build.query<Types.ReadGroupedPipelinesCountQuery, Types.ReadGroupedPipelinesCountQueryVariables>({
      query: (variables) => ({ document: ReadGroupedPipelinesCountDocument as unknown as string, variables })
    }),
    ReadUngroupedPipelinesCount: build.query<Types.ReadUngroupedPipelinesCountQuery, Types.ReadUngroupedPipelinesCountQueryVariables | void>({
      query: (variables) => ({ document: ReadUngroupedPipelinesCountDocument as unknown as string, variables })
    }),
    ReadGroupedPipelineCounts: build.query<Types.ReadGroupedPipelineCountsQuery, Types.ReadGroupedPipelineCountsQueryVariables>({
      query: (variables) => ({ document: ReadGroupedPipelineCountsDocument as unknown as string, variables })
    }),
    ReadLatestExecutionsForPipelines: build.query<Types.ReadLatestExecutionsForPipelinesQuery, Types.ReadLatestExecutionsForPipelinesQueryVariables>({
      query: (variables) => ({ document: ReadLatestExecutionsForPipelinesDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateGlobalBackupLifecycleSettingsMutation, useUpdateGlobalBackupLifecycleSettingsMutation, useDeleteGlobalBackupLifecycleSettingsMutation, useCreateDeviceBackupLifecycleSettingsMutation, useUpdateDeviceBackupLifecycleSettingsMutation, useDeleteDeviceBackupLifecycleSettingsMutation, useBulkCreateDeviceBackupLifecycleSettingsMutation, useBulkDeleteDeviceBackupLifecycleSettingsMutation, useReadGlobalBackupLifecycleSettingsQuery, useLazyReadGlobalBackupLifecycleSettingsQuery, useReadDeviceBackupLifecycleSettingsQuery, useLazyReadDeviceBackupLifecycleSettingsQuery, useListDeviceBackupLifecycleSettingsQuery, useLazyListDeviceBackupLifecycleSettingsQuery, useCreateDeploymentRequestMutation, useApproveDeploymentRequestMutation, useDenyDeploymentRequestMutation, useCancelDeploymentRequestMutation, useExecuteDeploymentRequestMutation, useDeleteDeploymentRequestMutation, useUpdateDeploymentRequestApproversMutation, useReadDeploymentRequestQuery, useLazyReadDeploymentRequestQuery, useReadDeploymentRequestsQuery, useLazyReadDeploymentRequestsQuery, useReadEligibleDeploymentApproversQuery, useLazyReadEligibleDeploymentApproversQuery, useCreatePipelineConfigurationMutation, useUpdatePipelineConfigurationMutation, useDeletePipelineConfigurationMutation, useTriggerPipelineExecutionMutation, useCreateConversionMutation, useDeleteJobMutation, useDeletePipelineExecutionMutation, useDownloadArtifactsForJobMutation, useCreateDeviceJobMutation, useCreateJobMutation, useReadAllPipelinesQuery, useLazyReadAllPipelinesQuery, useReadPipelinesForSelectQuery, useLazyReadPipelinesForSelectQuery, useReadPipelineExecutionsForPipelineQuery, useLazyReadPipelineExecutionsForPipelineQuery, useReadPipelineQuery, useLazyReadPipelineQuery, useReadVersionOriginJobsQuery, useLazyReadVersionOriginJobsQuery, useReadAllJobsQuery, useLazyReadAllJobsQuery, useReadJobsByDeviceIdsQuery, useLazyReadJobsByDeviceIdsQuery, useReadJobsByProjectIdQuery, useLazyReadJobsByProjectIdQuery, useReadJobsByProjectIdsQuery, useLazyReadJobsByProjectIdsQuery, useReadLatestJobsByProjectIdsQuery, useLazyReadLatestJobsByProjectIdsQuery, useReadPipelineExecutionQuery, useLazyReadPipelineExecutionQuery, useReadJobQuery, useLazyReadJobQuery, useReadJobLogsQuery, useLazyReadJobLogsQuery, useReadPipelineNamesForPolicyRowQuery, useLazyReadPipelineNamesForPolicyRowQuery, useReadGroupedPipelinesCountQuery, useLazyReadGroupedPipelinesCountQuery, useReadUngroupedPipelinesCountQuery, useLazyReadUngroupedPipelinesCountQuery, useReadGroupedPipelineCountsQuery, useLazyReadGroupedPipelineCountsQuery, useReadLatestExecutionsForPipelinesQuery, useLazyReadLatestExecutionsForPipelinesQuery } = injectedRtkApi;

